module.exports = __webpack_public_path__ + "img/icon-facebook.d0f90059.svg";